// The handful of elements a note is written in. Inline styles, like the rest
// of the site, so a note body reads as plain markup: <P>, <H2>, <List>.

import React from "react";

type Children = { readonly children: React.ReactNode };

export function P({ children }: Children): React.JSX.Element {
  return <p style={{ fontSize:17, color:"var(--text-soft)", lineHeight:1.8, margin:"0 0 22px" }}>{children}</p>;
}

export function H2({ children }: Children): React.JSX.Element {
  return <h2 style={{ fontFamily:"'Bebas Neue',cursive", fontWeight:400, fontSize:30, color:"var(--text-strong)", letterSpacing:"0.02em", lineHeight:1.15, margin:"40px 0 14px" }}>{children}</h2>;
}

export function List({ children }: Children): React.JSX.Element {
  return <ol style={{ margin:"0 0 22px", paddingLeft:24, display:"flex", flexDirection:"column", gap:14 }}>{children}</ol>;
}

export function Item({ title, children }: Children & { readonly title: string }): React.JSX.Element {
  return (
    <li style={{ fontSize:17, color:"var(--text-soft)", lineHeight:1.75, paddingLeft:4 }}>
      <strong style={{ color:"var(--text-strong)" }}>{title}</strong> {children}
    </li>
  );
}

/** A set-apart aside — --surface-raised, because --surface-sunken is white in light mode. */
export function Aside({ children }: Children): React.JSX.Element {
  return (
    <div style={{ background:"var(--surface-raised)", border:"1px solid var(--border-subtle)", borderRadius:10, padding:"20px 22px", margin:"8px 0 26px", fontSize:16, color:"var(--text-soft)", lineHeight:1.75 }}>
      {children}
    </div>
  );
}

export function Term({ children }: Children): React.JSX.Element {
  return <strong style={{ color:"var(--text-strong)", fontWeight:600 }}>{children}</strong>;
}
